export default {
  back: {
    en: 'Back',
  },
  next: {
    en: 'Next',
  },
  choose: {
    en: 'Choose',
  },
  chooseNow: {
    en: 'Choose now',
  },
  chooseFragrance: {
    en: 'Choose your fragrance',
  },
  accept: {
    en: 'Accept',
  },
  cancel: {
    en: 'Cancel',
  },
  confirm: {
    en: 'Confirm',
  },
  login: {
    en: 'Login',
  },
  finish: {
    en: 'Finish',
  },
  reject: {
    en: 'Reject',
  },
  save: {
    en: 'Save',
  },
  submit: {
    en: 'Submit',
  },
  subscribe: {
    en: 'Subscribe',
  },
  subscribeNow: {
    en: 'Subscribe now',
  },
  resubscribe: {
    en: 'Resubscribe',
  },
  resubscribeNow: {
    en: 'Resubscribe now',
  },
  unsubscribe: {
    en: 'Unsubscribe',
  },
  unpause: {
    en: 'Unpause',
  },
  upgrade: {
    en: 'Upgrade',
  },
  close: {
    en: 'Close',
  },
  orderNow: {
    en: 'Order now',
  },
  shopNow: {
    en: 'Shop now',
  },
  showMore: {
    en: 'Show more',
  },
  buyNow: {
    en: 'Buy now',
  },
  gotIt: {
    en: 'Got it!',
  },
  redeem: {
    en: 'Redeem',
  },
  getStarted: {
    en: 'Get started',
    es: 'Comienza ahora',
  },
  resetPassword: {
    en: 'Reset password',
  },
  update: {
    en: 'Update',
  },
  continue: {
    en: 'Continue',
  },
  neverMind: {
    en: 'Never mind',
  },
  reply: {
    en: 'Reply',
  },
  send: {
    en: 'Send',
  },
  imIn: {
    en: 'i\'m in',
  },
  checkout: {
    en: 'Checkout',
  },
  buyInOneClick: {
    en: 'Buy in one click',
  },
  learnMore: {
    en: 'Learn more',
  },
  loadMore: {
    en: 'Load more',
  },
} as const
